import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm, reset } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import { CommonButton } from '../../../../components/buttons';
// import RaisedButton from 'material-ui/RaisedButton';
import { renderAutoCompleteSingleSelect,
  renderTextField,
} from '../../../../components/reduxFields';
import { getPatientPayerServiceCodes } from './actions/soapActions';
import { Scrollbars } from 'react-custom-scrollbars';
const validate = (values) => {
  const errors = {};

  if (!values.CPTID || !Number.isInteger(values.CPTID)) {
    errors.CPTID = 'Please select CPT code.';
  }
  return errors;
};

// props.master_CPT ? props.master_CPT :

class CPTModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      masterCPT: [],
      isValidServiceCode: true,
    };
    this.filter = {
      searchText: '',
    };
    // this.handleSearchCPTcodes = this.handleSearchCPTcodes.bind(this);
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    this.setState({ open: false });
    this.props.closeDialog();
  };

  loadCPTs() { // description: this.filter.searchText,
    let searchObj = {
      patientId: this.props.patientId,
      payerPreference: 'primary',
      dateTime: this.props.dateOfService,
    };
    this.props.getPatientPayerServiceCodes(searchObj);
  }

  componentWillMount() {
    // this.props.getMasterData();
    this.loadCPTs();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.searched_CPTs && nextProps.searched_CPTs.length && this.props.searched_CPTs !== nextProps.searched_CPTs) {
      let CPTdata = [];
      nextProps.searched_CPTs.forEach((cpt, index) => {
        if (!this.props.cptArray.find((i) => i.ServiceCode === cpt.serviceCode)) {
          CPTdata.push({
            'id': cpt.serviceCodeId,
            'value': cpt.serviceCode,
            ...cpt,
          });
        }
      });
      if (CPTdata.length) {
        this.setState({ masterCPT: CPTdata });
      }
    }

    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
    let cptData = this.state.masterCPT.find((obj) => obj.id === selectedRecord.value);
    if (cptData) {
      let isValid = cptData.isAuthorizationMandatory ? cptData.isValid : true;
      this.setState({ isValidServiceCode: isValid });
    }
  }
  // handleSearchCPTcodes(value, dataSource) {
  //   // console.log(value);
  //   if (value.trim().length >= 3) {
  //     this.filter.searchText = value;
  //     this.loadCPTs();
  //   } else if (value === '') {
  //     this.filter.searchText = '';
  //     this.loadCPTs();
  //   }
  // }
  onAddSubmitHandler = (formProps) => {
    if (this.state.isValidServiceCode) {
      let cptData = this.state.masterCPT.find((obj) => obj.id === formProps.CPTID);
      if (cptData) {
        formProps.AuthProcedureCPTLinkId = cptData.authProcedureCPTLinkId;
        formProps.AuthorizationNumber = cptData.authorizationNumber;
      }
      this.props.handleAddCPT(formProps);
      this.handleClose();
    }
  }
  onAddMoreSubmitHandler = (formProps) => {
    if (this.state.isValidServiceCode) {
      let cptData = this.state.masterCPT.find((obj) => obj.id === formProps.CPTID);
      if (cptData) {
        formProps.AuthProcedureCPTLinkId = cptData.authProcedureCPTLinkId;
        formProps.AuthorizationNumber = cptData.authorizationNumber;
      }
      this.props.handleAddCPT(formProps);
      this.props.dispatch(reset('Form_SoapCPTModal'));
      this.filter.searchText = '';
      let cptCodes = this.state.masterCPT;
      let indexCpt = this.state.masterCPT.indexOf(cptData);
      cptCodes.splice(indexCpt, 1);
      this.setState({ masterCPT: cptCodes });
      // this.loadCPTs();
    }
  }

  render() {
    const { handleSubmit } = this.props;
    let btns = [
      <CommonButton label="Cancel" className="mr-15 grey_btn" onTouchTap={this.handleClose}/>,
      <CommonButton type="submit" label= "Add" className="mr-15" primary={true} onTouchTap={handleSubmit(this.onAddSubmitHandler)}/>,
      <CommonButton type="submit" primary={true} label= "Add More" onTouchTap={handleSubmit(this.onAddMoreSubmitHandler)}/>,
    ];

    const actions = [ <div className="sm-btn-scroll"><Scrollbars>{btns} </Scrollbars></div>]
    return (
      <div>
        {this.state.open ?
          <Dialog className="custom_modal"
            title={'Add Service Codes'}
            modal={false}
            open={this.state.open}
            actions={actions}
            // onRequestClose={this.handleClose}
            autoScrollBodyContent={true}
          >
            <div className="row">
              <div className="col-sm-12">
                <form className="readmin-form custom_form">
                  <div className="row">
                    <div className="col-sm-12 require mt-40">
                      <Field
                        name="CPTID"
                        label="Search Service Code"
                        options={this.state.masterCPT}
                        handleNewRequest={this.handleNewRequest}
                        // handleUpdateInput={this.handleSearchCPTcodes}
                        customError={!this.state.isValidServiceCode ? 'Selected service code is not authorized.' : undefined}
                        component={renderAutoCompleteSingleSelect}
                      />
                    </div>
                    <div className="col-sm-12">
                      <div className="row">
                        <div className="col-sm-3">
                          <Field
                            name="Modifier1"
                            label="Modifier 1"
                            component={renderTextField}
                          />
                        </div>
                        <div className="col-sm-3">
                          <Field
                            name="Modifier2"
                            label="Modifier 2"
                            disabled={!this.props.modifier1}
                            component={renderTextField}
                          />
                        </div>
                        <div className="col-sm-3">
                          <Field
                            name="Modifier3"
                            label="Modifier 3"
                            disabled={!this.props.modifier2}
                            component={renderTextField}
                          />
                        </div>
                        <div className="col-sm-3">
                          <Field
                            name="Modifier4"
                            label="Modifier 4"
                            disabled={!this.props.modifier3}
                            component={renderTextField}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </Dialog> : null}
      </div>
    );
  }
}

const selector = formValueSelector('Form_SoapCPTModal');
const mapStateToProps = (state, ownProps) => ({
  modifier1: selector(state, 'Modifier1'),
  modifier2: selector(state, 'Modifier2'),
  modifier3: selector(state, 'Modifier3'),
  modifier4: selector(state, 'Modifier4'),
  loading: state.soap.loading,
  searched_CPTs: state.soap.searched_CPTs && state.soap.searched_CPTs.data ? state.soap.searched_CPTs.data : [],
});

CPTModal = reduxForm({
  form: 'Form_SoapCPTModal',
  validate,
  enableReinitialize: true,
})(CPTModal);

export default connect(mapStateToProps, { getPatientPayerServiceCodes })(CPTModal);



// WEBPACK FOOTER //
// ./src/modules/scheduling/components/SessionNotes_SOAR/soap_CPTModal.js